// Os primitivos do painel de operação, compartilhados entre as abas.
//
// Nasceram como funções locais no fim de `SuporteAlunos.tsx` e foram extraídos
// VERBATIM quando a aba Triagem apareceu. O motivo não é organização: copiar o
// `Chip` criaria uma segunda definição do mapa tom→token, e é justamente ali que
// mora a armadilha de nome do design system —
//
//   `aviso-*` é a família VERDE de sucesso (`#ecfdf5` / `#065f46`)
//   `alerta-*` é a laranja de atenção (`rgb(255 153 51 / .16)` / `#8a4a00`)
//
// — enquanto a severidade `aviso` da triagem quer dizer "aplicado COM
// divergência", que é atenção. Duas definições e alguém pinta de verde-sucesso a
// linha que pede atenção. Aqui o mapa é um só: `tom="atencao"` para aviso,
// `tom="erro"` para falha.
import type { ReactNode } from "react";

export function Th({ children }: { children: ReactNode }) {
  return (
    <th className="pb-2 pr-3 text-xs font-bold tracking-wide text-cinza uppercase">{children}</th>
  );
}

export function Bloco({
  titulo,
  descricao,
  children,
}: {
  titulo: string;
  descricao: string;
  children: ReactNode;
}) {
  return (
    <section className="surface p-4 sm:p-5">
      <h3 className="font-display text-base font-bold text-titulo">{titulo}</h3>
      <p className="mt-0.5 max-w-3xl text-sm leading-relaxed text-cinza">{descricao}</p>
      <div className="mt-3">{children}</div>
    </section>
  );
}

export function Campo({ rotulo, valor }: { rotulo: string; valor: string }) {
  return (
    <div>
      <dt className="text-xs font-bold tracking-wide text-cinza uppercase">{rotulo}</dt>
      <dd className="mt-0.5 text-sm break-words text-tinta">{valor}</dd>
    </div>
  );
}

export function Vazio({ children }: { children: ReactNode }) {
  return <p className="text-sm text-cinza">{children}</p>;
}

export function Chip({
  children,
  tom = "neutro",
}: {
  children: ReactNode;
  tom?: "neutro" | "ok" | "atencao" | "erro";
}) {
  const tons = {
    neutro: "bg-chip text-chip-tinta",
    ok: "bg-aviso-fundo text-aviso-tinta",
    atencao: "bg-alerta-fundo text-alerta-tinta",
    erro: "bg-erro-fundo text-erro-tinta",
  };
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${tons[tom]}`}
    >
      {children}
    </span>
  );
}
